import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { makeStyles, tokens } from '@fluentui/react-components';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { useAuth } from '../../hooks/useAuth';
import { apiClient } from '../../api/client';
import { UpdateBanner } from '../UpdateBanner';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    overflow: 'hidden',
  },
  container: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
  },
  main: {
    flex: 1,
    overflow: 'auto',
    backgroundColor: tokens.colorNeutralBackground2,
    padding: tokens.spacingHorizontalXXL,
  },
});

export function AppLayout() {
  const styles = useStyles();
  const { getAccessToken } = useAuth();

  // Set up API client with token getter
  useEffect(() => {
    apiClient.setTokenGetter(getAccessToken);
  }, [getAccessToken]);

  return (
    <div className={styles.root}>
      <UpdateBanner />
      <Header />
      <div className={styles.container}>
        <Sidebar />
        <main className={styles.main}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
